export const STAGE_ACCESS_TYPE_PUBLIC = 'public'
export const STAGE_ACCESS_TYPE_PRIVATE = 'private'
